import React from 'react';
import { IoMdMenu } from 'react-icons/io';
import { FiArrowLeft } from 'react-icons/fi';

import FormStatus from './FormStatus';
import classNames from 'classnames';
import { useGetMe } from 'legacy/user/hooks';
import { useTranslation } from 'react-i18next';

interface HeaderProps {
  title: string;
  description?: string;
  lastUpdated?: string;
  isLoading?: boolean;
  onBack: () => void;
  onMenuClick?: () => void;
  isEditing?: boolean;
  isDraft: boolean;
  className?: string;
}

const Header: React.FC<HeaderProps> = ({
  title,
  lastUpdated,
  isLoading,
  onBack,
  onMenuClick,
  isEditing,
  isDraft,
  description,
  className
}) => {
  const { data: user } = useGetMe();
  const { t } = useTranslation(['events']);
  return (
    <div
      className={classNames(
        'fixed h-14 md:h-16 top-0 lg:top-[50px] left-0 w-full px-4 py-2 md:py-6 bg-white shadow-sm z-50 flex items-center',
        {
          'md:top-[80px]': !!user
        },
        className
      )}
    >
      <div className="w-full flex items-center justify-between  md:w-[800px] md:mx-auto">
        <div className="flex items-center">
          <button
            type="button"
            className="mr-2"
            onClick={onBack}
            aria-label="back"
          >
            <FiArrowLeft size={24} className="text-gray-400" />
          </button>

          <div className="md:flex md:items-center">
            <h1 className="text-black text-base md:text-xl md:font-semibold md:mr-4">
              {title}
            </h1>
            {lastUpdated && (
              <p className="font-normal text-gray-600 text-sm flex items-center">
                <FormStatus lastUpdated={lastUpdated} isLoading={isLoading} />
              </p>
            )}
            {description && (
              <p className="font-normal text-gray-600 text-sm flex items-center">
                {description}
              </p>
            )}
          </div>
        </div>

        <div className="flex items-center">
          {isDraft && (
            <div className="mr-3">
              <div className="border-1 rounded-full px-3 py-1">
                {t('events:host.draft')}
              </div>
            </div>
          )}
          {!isDraft && isEditing && (
            <div className="mr-3">
              <div className="border-1 rounded-full px-3 py-1">
                {t('events:host.editMode')}
              </div>
            </div>
          )}

          {onMenuClick && (
            <button type="button" onClick={onMenuClick} aria-label="menu">
              <IoMdMenu size={24} className="text-primary-500" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
